import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "stroke-width", "fill", "viewBox"]
const _hoisted_2 = ["d"]

import { computed } from 'vue';
import stylesJS from '@/assets/styles.js';
import svgJSON from '@/assets/svg.json';


export default /*@__PURE__*/_defineComponent({
  __name: 'svgItem',
  props: {
  icon: {
    type: String,
    required: true,
  },
  styles: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    default: "",
  },
  active: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const svg = computed(() => {
  return svgJSON[props.icon]
})

const svgFill = computed(() => {
  return props.active ? 'currentColor' : svg.value ? svg.value.fill : ''
})

const svgSize = computed(() => {
  return props.size ? props.size : "100%";
})

const svgStrWidth = computed(() => {
  if (svgFill.value === 'currentColor') {return 0;}
  const importOBJ = stylesJS.get(props.styles)
  return importOBJ.pencil || svg.value?.strWidth || 2
})

const classList = computed(() => {
  // Import & defaults
  const importOBJ = stylesJS.get(props.styles)
  let iMain = importOBJ.main || "h"
  iMain = "main-" + iMain
  let iSize = importOBJ.size || "m"
  iSize = "item-" + iSize

  return [iMain, iSize]
})


return (_ctx: any,_cache: any) => {
  return (svg.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(classList.value)
      }, [
        (_openBlock(), _createElementBlock("svg", {
          width: svgSize.value,
          preserveAspectRatio: "xMidYMid meet",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": svgStrWidth.value,
          stroke: "currentColor",
          fill: svgFill.value,
          viewBox: svg.value.viewBox
        }, [
          _cache[0] || (_cache[0] = _createTextVNode(" > ")),
          _createElementVNode("path", {
            d: svg.value.path
          }, null, 8, _hoisted_2)
        ], 8, _hoisted_1))
      ], 2))
    : _createCommentVNode("", true)
}
}

})